module.exports = __webpack_public_path__ + "img/downarrow.64e041b9.svg";